import React from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import { setFavoriteCameras, setDialogInfo } from '../../redux/traffic-live';
import { deleteDeviceCamerasFavorite } from '../../api/deviceAPI';
var t = i18n.getFixedT(null, 'traffic-live');
var MyFavorite = /*#__PURE__*/React.memo(function () {
  // redux data, dispatch
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      favoriteCameras = _useSelector.trafficLive.favoriteCameras;

  var dispatch = useDispatch();

  var handleDisableCamera = function handleDisableCamera(id) {
    deleteDeviceCamerasFavorite(contextRoot, id).then(function (deletedId) {
      var newFavoriteCameras = _.cloneDeep(favoriteCameras);

      _.remove(newFavoriteCameras, function (el) {
        return el.id === deletedId;
      });

      dispatch(setFavoriteCameras(newFavoriteCameras));
    });
  };

  var openDialog = function openDialog(data) {
    dispatch(setDialogInfo({
      mode: 'camera',
      data: data
    }));
  }; // 缺 open camera live rtsp


  return /*#__PURE__*/React.createElement("div", {
    className: "myFavorite"
  }, _.map(favoriteCameras, function (el) {
    return /*#__PURE__*/React.createElement("div", {
      className: "camera-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "camera-video"
    }, /*#__PURE__*/React.createElement("i", {
      className: "far fa-play-circle play-icon",
      onClick: function onClick() {
        return openDialog(el);
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "camera-info"
    }, /*#__PURE__*/React.createElement("p", {
      className: "camera-name",
      title: el.name
    }, el.name), /*#__PURE__*/React.createElement("p", {
      className: "camera-area",
      title: el.location
    }, el.location), /*#__PURE__*/React.createElement("i", {
      className: "fas fa-heart heart-icon",
      onClick: function onClick() {
        return handleDisableCamera(el.id);
      }
    })));
  }));
});
export default MyFavorite;